<template>

     
<div v-if="isOpenEnquiries || !uncompletedOnly" class="card shadow mb-2"><div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4 card-body pb-1 pt-1">
      <div class="table-responsive-xl">
        <div>
          <table class="fixed selectable">
          <thead>
            <tr>
              <th class="col-date">Enquiry Date</th>
  
              <!--<<th>Collection</th>-->
              <th>Name</th>
              <th class="col-date">Phone</th>
  
              <!--<<th>Alt Phone</th>-->
              <th class="col-address col-address-lg">Enquiry Message</th>
              <th class="col-status">Status</th>
              <th class="col-job">Assigned</th>
  
  
              <!--<th>Accounts</th><th>Return</th><th>Attachment</th><th>Items</th>-->
              <th class="col-arrow"></th>
            </tr>
          </thead>
          <tbody>
  
            <template v-for="(contact, index) in contacts">
              <router-link v-if="(uncompletedOnly && contact.status !== 'Completed') && (uncompletedOnly && contact.status !== 'Cancelled') || !uncompletedOnly" v-bind:class="{disable: contact.status==='Cancelled' }" class="rw" tag="tr" :to="{ name: 'enquiry-view', params: { id: contact['contactid'], key: contact['.key'] } }" v-bind:key="index">
                                                      
  
  
              <td class="col-date" :time="contact.submitted">{{contact.submitted | shortDate}}</td>
              <!--<td>{{job.collection}}</td>-->
              <td :title="contact.name + ' (' + contact.email + ')'">{{contact.name}} <small>({{contact.email}})</small></td>
              <td class="col-date">{{contact.phone}}</td>
              <!--<td>{{job.altphone}}</td>-->
              <td class="col-address col-address-lg">{{contact.message}}</td>
              <td class="col-status"><span style="margin:auto 0;"  :style="{ background: $options.filters.statusHex(contact.status)}" class="badge badge-lg">{{contact.status}}</span></td>
              <td class="col-job"><div v-html="$options.filters.getCaps(contact.assignedTo, contact.assignedUID, users)"></div></td>
              <!--<td>
                <div class="nav-item dropdown hover-dropdown">
                  <button class="btn p-2 nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                  <div class="dropdown-menu dropdown-menu-right animated--fade-in" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </div>
                </div>
              </td>-->
              <td class="col-arrow"><i class="fas fa-fw fa-chevron-right"> </i></td>
            </router-link>
            </template>
          </tbody>
        </table>
        </div>
        </div>
        </div></div>
  </template>
  
  <script>
  //import Modal from '../components/Modal.vue'
  // Get a RTDB instance
  
  import { db } from "../main";
  const contactsRaw = db.ref("contactForm2020");

  export default {
    name: "EnquiryTable",
    components: {
    },
    data() {
      return {
        contactsRaw: [],
        opened: [],
        users: [],
        contactsClosedRaw: []
      };
    },
    props: {
        uncompletedOnly: {
              type: Boolean,
        },
        limit: {
            type: Number,
            default: 100
        }
    },
    computed: {
      contacts: function () {
        return [...this.contactsRaw].reverse();
      },
      isOpenEnquiries: function () {

        var isOpen = false;
        this.contacts.forEach(function(item){
          if(item.status === "In Process" || item.status === "Created"){
            isOpen = true;
            return;
          }
        })
        return isOpen;
      }
    },
    created: function () {
        this.$rtdbBind("contactsRaw", contactsRaw.orderByChild("contactid").limitToLast(this.limit));
    },
    methods: {
      toggle(id) {
        const index = this.opened.indexOf(id);
        if (index > -1) {
          this.opened.splice(index, 1);
        } else {
          this.opened.push(id);
        }
      },
    },
    firebase: {
      users: db.ref('users').orderByChild('role').limitToLast(50).startAt(8),
      //contactsClosedRaw: db
      //  .ref("contactForm")
      //  .orderByChild("contactid")
      // .limitToLast(50),
    },
  };
  </script>
  
  